/**
 * Tira um atributo de TODOS os trechos de um Delta do Quill (ex.: `font`, quando a fonte do
 * documento inteiro muda). Devolve o JSON novo, ou `null` quando não é um Delta ou nada
 * mudou (quem chama não salva à toa).
 */
export function stripDeltaAttribute(deltaJson: string, attribute: string): string | null {
    if (!deltaJson || !deltaJson.includes(`"${attribute}"`)) return null;

    let parsed: { ops?: unknown[] };
    try {
        parsed = JSON.parse(deltaJson);
    } catch {
        return null;
    }
    if (!Array.isArray(parsed?.ops)) return null;

    let changed = false;
    const ops = parsed.ops.map(op => {
        if (op === null || typeof op !== 'object') return op;
        const { attributes, ...rest } = op as { attributes?: Record<string, unknown> };
        if (!attributes || !(attribute in attributes)) return op;

        changed = true;
        const { [attribute]: _removed, ...kept } = attributes;
        return Object.keys(kept).length > 0 ? { ...rest, attributes: kept } : rest;
    });

    return changed ? JSON.stringify({ ...parsed, ops }) : null;
}
